module.exports = __webpack_public_path__ + "static/img/dsk-service-bg1.44d8061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-service-bg1.jpg
// module id = 236
// module chunks = 1